import "./style.css";
import "webgl-lint";
import * as THREE from "three";
import Stats from "three/examples/jsm/libs/stats.module";
import Renderable from "./Renderable";
import fragment from "./shaders/shader/uvcolor.frag";
import vert from "./shaders/shader/main.vert";

class Sketch implements Renderable {
  private readonly camera: THREE.PerspectiveCamera;
  private readonly renderer: THREE.WebGLRenderer;
  private readonly scene: THREE.Scene;
  private readonly stats: Stats;
  private sceneObjects: Array<THREE.Object3D> = [];

  constructor(el: string) {
    const container = document.querySelector<HTMLDivElement>(el)!;

    this.renderer = new THREE.WebGLRenderer({antialias: true});
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setClearColor(0x000000, 0.0);
    this.renderer.setSize(container.clientWidth, container.clientHeight);
    container.append(this.renderer.domElement);

    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color("black");

    this.camera = new THREE.PerspectiveCamera(60, container.clientWidth / container.clientHeight, 1, 1000);
    this.camera.position.set(0, 0, 5);

    window.addEventListener("resize", () => this.onWindowResize());

    this.stats = new Stats();
    document.body.appendChild(this.stats.dom);

    const dirLight1 = new THREE.DirectionalLight(0xffffff);
    dirLight1.position.set(1, 1, 1);
    this.scene.add(dirLight1);

    const dirLight2 = new THREE.DirectionalLight(0x002288);
    dirLight2.position.set(-1, -1, -1);
    this.scene.add(dirLight2);

    const ambientLight = new THREE.AmbientLight(0x222222);
    this.scene.add(ambientLight);

    const cube = this.addExperimentalCube();
    this.scene.add(cube);
    this.sceneObjects.push(cube);

    this.animate();
  }
  animate(): void {
    window.requestAnimationFrame(() => this.animate());
    this.stats.update();
    this.render();
    for (const object of this.sceneObjects) {
      object.rotation.x += 0.01;
      object.rotation.y += 0.03;
    }
  }

  render(): void {
    this.renderer.render(this.scene, this.camera);
  }

  onWindowResize(): void {
    this.camera.aspect = window.innerWidth / window.innerHeight;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(window.innerWidth, window.innerHeight);
  }

  addExperimentalCube(): THREE.Mesh {
    const uniforms = {
      colorB: {type: "vec3", value: new THREE.Color(0xacb6e5)},
      colorA: {type: "vec3", value: new THREE.Color(0x74ebd5)}
    };

    const geometry = new THREE.BoxGeometry(1, 1, 1);
    const material = new THREE.ShaderMaterial({
      uniforms: uniforms,
      fragmentShader: fragment,
      vertexShader: vert,
      glslVersion: "300 es"
    });

    const mesh = new THREE.Mesh(geometry, material);
    return mesh;
  }
}
export default new Sketch("#scene-container");
